<div #viewerDiv
     style="width: 100%; height: 600px;"
      >
</div>
